module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-62.aa8f1e3c.svg";